<template>
  <sc-select
    :disabled="disabled"
    v-model="deliveryMethod"
    @input="changeDeliveryMethod"
    expanded>
      <option
        v-for="deliveryMethodSrc in allDeliveryMethods"
        :key="deliveryMethodSrc.id"
        :value="deliveryMethodSrc.id">
          {{ deliveryMethodSrc.name }}
      </option>
  </sc-select>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScSelect,
  } from '@intelipost-js/secure-components';

  const { mapGetters, mapActions } = createNamespacedHelpers('logisticProviders');

  export default {
    name: 'sc-quoting-dm-all',
    props: {
      value: {
        type: [Number, String],
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      defaultValue: {
        type: Number,
        default: 1,
      },
      callGetDmAll: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ...mapGetters([
        'allDeliveryMethods',
      ]),
    },
    data() {
      return {
        deliveryMethod: this.value || this.defaultValue,
      };
    },
    watch: {
      value(value) {
        this.deliveryMethod = value;
      },
      deliveryMethod(deliveryMethod) {
        this.$emit('input', deliveryMethod);
      },
    },
    methods: {
      ...mapActions([
        'getLogisticProviders',
      ]),
      changeDeliveryMethod(event) {
        this.$emit('input', event);
      },
    },
    created() {
      if (this.callGetDmAll) {
        this.getLogisticProviders();
      }
    },
    components: {
      ScSelect,
    },
    mounted() {
      this.$emit('input', this.defaultValue);
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-dm-all/ScQuotingDmAll.vue